import { storeToRefs } from 'pinia'
import { useAuthStore } from '../../stores/authStore'
import { useLogger } from '../../composables/useLogger'

const logger = useLogger()

export function getUserId() {
    const authStore = useAuthStore()
    const { userId } = storeToRefs(authStore)
    return userId.value
}